import { transformExpenseByArticlesReportToTableData } from './transformExpenseByArticlesReportToTableData';

export { transformExpenseByArticlesReportToTableData };
